import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {Alert, Loading} from 'Components/Partials';
import {FormHandler, Input, Textarea, FileUpload, WYSIWYG} from 'Components/Form';
import {PrimaryButton} from 'Components/Button';

import ExhibitorApi from 'Services/Api/Exhibitor/Exhibitor';

class UpdateExhibitor extends React.Component {

    /**
     * @var state
     */
    state = {
        loading: true,
    }

    /**
     * @var success
     * @type {string}
     */
    success = 'Your exhibitor data has been updated';

    /**
     * @method componentDidMount
     */
    componentDidMount = async () => {
        const {setForm, exhibitor} = this.props;

        setForm(exhibitor);

        this.setState({loading: false});
    }

    /**
     * @method handleSubmit
     * @param {Event} e
     */
    handleSubmit = async (e) => {
        e.preventDefault();

        const {form, setAlert, setWorking, exhibitor, submitCallback} = this.props;

        setWorking(true);

        let response = await ExhibitorApi.updateExhibitor(exhibitor.id, form);

        if (!response.success) {
            setAlert('error', response.message, response.errors);
            setWorking(false);
            return false;
        } else {
            setAlert('success', this.success, {});
            submitCallback();
            this.props.onClose();
        }
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {form, handleInput, getFieldError, alert, working, exhibitor, field} = this.props;
        const {loading} = this.state;

        return (
            <Modal size="max-w-screen-md">
                <ModalHeader onClose={this.props.onClose}>
                    Update your exhibitor data
                </ModalHeader>

                {loading && (<Loading />)}

                {!loading &&
                    <form onSubmit={e => this.handleSubmit(e)}>
                        <ModalBody>
                            {alert && (<Alert {...alert} />)}

                            <Input
                                containerClassName="my-4"
                                label="Name"
                                type="text"
                                value={form.name}
                                error={getFieldError('name')}
                                onChange={v => handleInput('name', v)}
                                labelColour="text-app-blue"
                            />

                            <Input
                                containerClassName="my-4"
                                label="Email"
                                type="text"
                                value={form.email}
                                error={getFieldError('email')}
                                onChange={v => handleInput('email', v)}
                                labelColour="text-app-blue"
                            />

                            <Textarea
                                containerClassName="my-4"
                                label="Menu Bio"
                                value={form.menu_bio}
                                error={getFieldError('menu_bio')}
                                onChange={v => handleInput('menu_bio', v)}
                                labelColour="text-app-blue"
                            />

                            <WYSIWYG
                                containerClassName="my-4"
                                label="Download Blurb"
                                value={form.download_blurb}
                                error={getFieldError('download_blurb')}
                                onChange={v => handleInput('download_blurb', v)}
                            />

                            <FileUpload
                                containerClassName="my-4"
                                label="Logo"
                                value={form.logo}
                                error={getFieldError('logo')}
                                onChange={v => handleInput('logo', v)}
                                accept='image/*'
                                placeholder="Update file"
                            />

                            <FileUpload
                                containerClassName="my-4"
                                label="Banner"
                                value={form.banner}
                                error={getFieldError('banner')}
                                onChange={v => handleInput('banner', v)}
                                accept='image/*'
                                placeholder="Update file"
                            />

                            <WYSIWYG
                                containerClassName="my-4"
                                label="Blurb"
                                value={form.blurb}
                                error={getFieldError('blurb')}
                                onChange={value => handleInput('blurb', value)}
                            />

                            <Input
                                containerClassName="my-4"
                                label={'Video 1 (As https://www.youtube.com/embed/xyz or https://player.vimeo.com/video/xyz where "xyz" is the video code)'}
                                type="text"
                                value={form.video}
                                error={getFieldError('video')}
                                onChange={v => handleInput('video', v)}
                                labelColour="text-app-blue"
                            />

                            <Input
                                containerClassName="my-4"
                                label={'Video 2 (As https://www.youtube.com/embed/xyz or https://player.vimeo.com/video/xyz where "xyz" is the video code)'}
                                type="text"
                                value={form.video_two}
                                error={getFieldError('video_two"')}
                                onChange={v => handleInput('video_two', v)}
                                labelColour="text-app-blue"
                            />

                            <Input
                                containerClassName="my-4"
                                label={'Video 3 (As https://www.youtube.com/embed/xyz or https://player.vimeo.com/video/xyz where "xyz" is the video code)'}
                                type="text"
                                value={form.video_three}
                                error={getFieldError('video_three"')}
                                onChange={v => handleInput('video_three', v)}
                                labelColour="text-app-blue"
                            />

                            <Input
                                containerClassName="my-4"
                                label={'Video 4 (As https://www.youtube.com/embed/xyz or https://player.vimeo.com/video/xyz where "xyz" is the video code)'}
                                type="text"
                                value={form.video_four}
                                error={getFieldError('video_four"')}
                                onChange={v => handleInput('video_four', v)}
                                labelColour="text-app-blue"
                            />
                        </ModalBody>

                        <ModalFooter alignment="center">
                            <PrimaryButton
                                text="Close"
                                onClick={this.props.onClose}
                                className="mr-2"
                            />

                            <PrimaryButton
                                className="ml-2"
                                text="Update"
                                disabled={working}
                                working={working}
                            />
                        </ModalFooter>
                    </form>
                }
            </Modal>
        )
    }
}

export default FormHandler(UpdateExhibitor);
